var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmily(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "600px",
    height: "600px",
    xlink: "http://www.w3.org/1999/xlink",
    style: {
      overflow: "hidden!important"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-wrapper",
    transform: "scale(3 3)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-backs-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4099",
    d: "M225 225H-25V-25h250V225z",
    fill: "#547980",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4100",
    d: "M30.816 56.624l3.375 1.049 -2.886 2.041 0.045 3.535 -2.833-2.114 -3.347 1.136 1.134-3.348 -2.114-2.833 3.535 0.044 2.041-2.886L30.816 56.624zM40.051 33.259l-1.586 5.428 -5.372 1.771 4.672 3.187L37.79 49.3l4.475-3.458 5.385 1.725 -1.905-5.325 3.303-4.588 -5.653 0.168L40.051 33.259zM9.358 99.38l-2.422 3.986 -4.711 0.273 3.104 3.526 -1.17 4.508 4.344-1.807 3.987 2.514 -0.421-4.643 3.633-2.954 -4.602-1.063L9.358 99.38zM11.271 71.054l0.168 3.531 -2.814 2.14 3.41 0.932 1.166 3.337 1.939-2.955 3.534-0.077 -2.21-2.759 1.019-3.384 -3.306 1.25L11.271 71.054zM5.396 51.958l3.615-2.959 0.182 4.63 3.969 2.479L8.755 57.71 7.592 62.2l-2.905-3.641L0 58.856l2.612-3.853 -1.735-4.307L5.396 51.958zM5.222 135.998l2.556-1.095 -0.621 2.515 1.908 1.88 -2.799 0.256 -1.377 2.256 -1.111-2.357 -2.758-0.484 2.115-1.714 -0.329-2.556L5.222 135.998zM20.532 155.007l2.81 0.867 -2.402 1.688 0.038 2.922 -2.358-1.748 -2.785 0.939 0.943-2.768 -1.76-2.342 2.942 0.037 1.699-2.387L20.532 155.007zM31.034 83.795l4.647 0.739 -3.406 3.215 0.738 4.622 -4.139-2.236 -4.191 2.116 0.849-4.598 -3.329-3.312 4.666-0.606 2.132-4.164L31.034 83.795zM22.119 29.902l5.203 1.198 -4.104 3.329 0.474 5.232 -4.507-2.832 -4.909 2.035 1.322-5.08 -3.509-3.974 5.325-0.307 2.738-4.491L22.119 29.902zM26.758 136.314l4.432-0.083 -2.633 3.463 1.437 4.064 -4.2-1.354L22.251 145l0.04-4.301 -3.627-2.46 4.226-1.304 1.298-4.115L26.758 136.314zM56.458 148.571l4.296-0.914 -1.894 3.861 2.184 3.68 -4.349-0.525 -2.947 3.188 -0.792-4.187 -4.005-1.709 3.86-2.063 0.468-4.242L56.458 148.571zM41.369 162.985l5.203 1.198 -4.104 3.329 0.474 5.232 -4.507-2.832 -4.909 2.035 1.322-5.08 -3.509-3.975 5.325-0.307 2.738-4.491L41.369 162.985zM30.869 110.835l5.203 1.199 -4.104 3.328 0.474 5.232 -4.507-2.832 -4.909 2.035 1.322-5.08 -3.509-3.974 5.325-0.308 2.738-4.49L30.869 110.835zM45.782 133.007l2.81 0.867 -2.402 1.688 0.038 2.922 -2.358-1.748 -2.785 0.939 0.943-2.768 -1.76-2.342 2.942 0.037 1.699-2.387L45.782 133.007zM39.066 13.124l3.375 1.049 -2.886 2.041 0.045 3.535 -2.833-2.114 -3.347 1.136 1.134-3.348 -2.114-2.833 3.535 0.044 2.041-2.886L39.066 13.124zM60.934 3.517L65.4 3.387l-2.609 3.538 1.505 4.106 -4.255-1.331 -3.536 2.667 -0.019-4.36L52.795 5.55l4.244-1.365L58.293 0 60.934 3.517zM65.782 172.007l2.81 0.867 -2.402 1.688 0.038 2.922 -2.358-1.748 -2.785 0.939 0.943-2.768 -1.76-2.342 2.942 0.037 1.699-2.387L65.782 172.007zM49.908 108.489l4.072-0.469 -2.299 3.158 1.465 3.299 -3.91-0.764 -3.165 2.505 -0.116-3.63 -3.422-1.752 3.84-1.479 1.047-3.586L49.908 108.489zM169.184 120.86l-3.376-1.049 2.886-2.041 -0.045-3.535 2.833 2.113 3.347-1.135 -1.134 3.348 2.114 2.832 -3.535-0.045 -2.04 2.887L169.184 120.86zM159.948 144.224l1.587-5.428 5.371-1.771 -4.672-3.187 -0.024-5.655 -4.475 3.458 -5.386-1.725 1.905 5.325 -3.303 4.589 5.652-0.168L159.948 144.224zM190.642 78.103l2.422-3.986 4.712-0.273 -3.104-3.526 1.17-4.508 -4.345 1.807 -3.987-2.514 0.421 4.643 -3.633 2.954 4.602 1.063L190.642 78.103zM188.729 106.43l-0.168-3.531 2.814-2.14 -3.409-0.932L186.8 96.49l-1.939 2.955 -3.534 0.077 2.211 2.759 -1.02 3.384 3.307-1.25L188.729 106.43zM194.604 125.525l-3.615 2.959 -0.182-4.63 -3.969-2.479 4.406-1.602 1.163-4.49 2.905 3.642 4.688-0.298 -2.612 3.853 1.735 4.307L194.604 125.525zM194.778 41.485l-2.556 1.095 0.62-2.515 -1.907-1.88 2.799-0.256 1.377-2.256 1.11 2.357 2.759 0.484 -2.115 1.714 0.329 2.556L194.778 41.485zM179.468 22.477l-2.811-0.867 2.402-1.688L179.022 17l2.358 1.748 2.784-0.939 -0.943 2.768 1.76 2.342 -2.942-0.037 -1.699 2.387L179.468 22.477zM168.966 93.688l-4.647-0.739 3.406-3.215 -0.738-4.622 4.139 2.236 4.191-2.116 -0.85 4.598 3.329 3.312 -4.665 0.606 -2.132 4.164L168.966 93.688zM177.881 147.581l-5.203-1.198 4.104-3.329 -0.474-5.232 4.507 2.832 4.909-2.035 -1.322 5.08 3.509 3.975 -5.325 0.307 -2.737 4.491L177.881 147.581zM173.241 41.169l-4.432 0.083 2.634-3.463 -1.437-4.064 4.2 1.354 3.541-2.595 -0.039 4.301 3.627 2.46 -4.226 1.304 -1.299 4.115L173.241 41.169zM151.968 35.013l-4.296 0.914 1.894-3.861 -2.185-3.68 4.349 0.525 2.947-3.188 0.792 4.187 4.006 1.709 -3.86 2.063 -0.469 4.242L151.968 35.013zM158.631 14.498l-5.203-1.198 4.104-3.329 -0.474-5.232 4.507 2.832 4.909-2.035 -1.322 5.08 3.509 3.975 -5.325 0.307 -2.737 4.491L158.631 14.498zM169.131 66.648l-5.203-1.199 4.104-3.328 -0.474-5.232 4.507 2.832 4.909-2.035 -1.322 5.08 3.509 3.974 -5.325 0.308 -2.737 4.49L169.131 66.648zM131.544 149.7l-2.81-0.867 2.402-1.688 -0.038-2.922 2.358 1.748 2.784-0.939 -0.943 2.768 1.76 2.342 -2.942-0.037 -1.699 2.387L131.544 149.7zM160.934 164.36l-3.376-1.049 2.886-2.041 -0.045-3.535 2.833 2.113 3.347-1.135 -1.134 3.348 2.114 2.832 -3.535-0.045 -2.04 2.887L160.934 164.36zM139.065 173.967l-4.466 0.13 2.609-3.539 -1.505-4.105 4.255 1.33 3.535-2.667 0.019 4.36 3.691 2.457 -4.243 1.365 -1.254 4.186L139.065 173.967zM134.218 5.477l-2.811-0.867 2.402-1.688L133.772 0l2.358 1.748 2.784-0.939 -0.943 2.768 1.76 2.342 -2.942-0.037 -1.699 2.387L134.218 5.477zM151.776 111.519l-4.072 0.469 2.299-3.158 -1.465-3.299 3.91 0.764 3.165-2.505 0.115 3.63 3.423 1.752 -3.84 1.479 -1.048 3.586L151.776 111.519z",
    fill: "#6c8a8f",
    strokeWidth: "none",
    opacity: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-subwrapper",
    transform: "matrix(0.84999948 0 0 0.84999948 14.980551414553048 17.66053061192234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2969",
    d: "M160 24.999H40c0 0-1 193.284-1 199h123L160 24.999z",
    fill: "#0c080c",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanbody-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2761",
    d: "M190.858 199.866c-6.008-10.158-13.474-11.973-19.628-13.936 -6.323-2.016-19.346-3.178-26.449-4.6 -6.86-1.373-23.153-5.789-23.339-13.488 -0.192-8.066 4.291-40.09 4.291-40.09H74.005c0 0 4.487 32.023 4.294 40.09 -0.184 7.699-16.48 12.115-23.341 13.488 -7.104 1.422-20.125 2.584-26.448 4.6 -6.156 1.963-13.624 3.777-19.632 13.936 -3.644 6.16-6.008 16.133-6.008 27.133h194C196.869 215.999 194.509 206.026 190.858 199.866z",
    fill: "#f3d4cf",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2762",
    d: "M121.442 167.843c2.495 10.929 18.165 13.698 26.293 15.325 21.909 4.379 33.772 5.134 42.297 19.539 2.903 4.916 5.459 15.864 5.962 24.153 1.835 0.291 0.531-17.432-5.136-26.994 -9.742-16.472-29.089-15.135-46.077-18.535C137.921 179.958 121.628 175.542 121.442 167.843L121.442 167.843zM78.558 167.843c-0.186 7.699-16.479 12.115-23.339 13.488 -16.988 3.4-36.335 2.063-46.077 18.535 -5.667 9.563-6.971 27.285-5.136 26.994 0.503-8.289 3.059-19.237 5.962-24.153 8.524-14.405 20.388-15.16 42.297-19.539C60.393 181.541 76.063 178.771 78.558 167.843L78.558 167.843z",
    fill: "#fff4f3",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2763",
    d: "M51.206 189.513c0 0 28.641 0.299 33.473 1.885 2.314 0.758 8.372 5.633 8.372 5.633s-6.556-3.17-8.658-3.758C79.51 191.909 51.206 189.513 51.206 189.513zM99.795 199.999c2.053-0.041 7.887-3.799 7.887-3.799s-5.574 2.059-7.342 2.16c-1.491 0.086-6.366-1.238-6.366-1.238S98.112 200.032 99.795 199.999zM117.008 192.757c6.75-1.818 29.786-3.23 29.786-3.23s-23.791-0.516-30.51 1.725c-2.252 0.752-7.562 5.16-7.562 5.16S114.786 193.354 117.008 192.757z",
    fill: "#e4b3ab",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2764",
    d: "M190.858 199.866c-9.741-16.471-29.122-15.142-46.077-18.535 -6.86-1.373-23.153-5.789-23.339-13.488 -0.192-8.066 4.291-40.09 4.291-40.09H74.005c0 0 4.487 32.023 4.294 40.09 -0.184 7.699-16.48 12.115-23.341 13.488 -7.104 1.422-20.125 2.584-26.448 4.6 -6.156 1.963-13.624 3.777-19.632 13.936 -3.644 6.16-6.008 16.133-6.008 27.133h194C196.869 215.999 194.509 206.026 190.858 199.866z",
    fill: "none",
    stroke: "#c5796d",
    strokeWidth: 1.5,
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-chinshadow-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4018",
    d: "M83.869 167.568c7.443 3.113 24.852 3.176 32.267 0 1.555-0.665 3.14-1.648 4.733-2.873 0.526-9.943 3.455-31.496 4.102-36.179l0.017-0.113H82.682c-2.727 0.202-5.355 0.438-7.833 0.709 0.778 5.658 3.493 25.843 4.016 35.462C80.559 165.857 82.236 166.886 83.869 167.568z",
    fill: "url(#SvgjsLinearGradient4019)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-clothes-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2991",
    d: "M190.188 199.647c-9.662-17.92-26.803-14.749-44.614-19.556 -1.348 1.637-13.686 17.468-16.485 25.934 -1.572-1.256-3.449-2.938-4.804-4.477 -6.628-7.46-16.453-31.601-19.75-12.749 0.717-8.463 4.614-10.327 10.025-3.234 5.817 7.633 6.033 11.575 14.333 19.875 1.466-5.831 4.273-10.037 7.966-15.201 3.573-5.005 6.435-8.945 10.566-12.492 -2.261-1.226-4.647-2.217-6.801-3.596 -13.515-8.76-5.435-17.647-17.685-19.764 -0.096 1.058-0.217 2.245-0.317 3.137 2.619 1.29 3.128 6.32-0.905 10.002 -6.41 6.742-14.866 7.077-17.552 17.429l-0.006-0.001c-0.854 3.071-1.539 7.776-1.863 10.533l-4.542 0.389c-1.847-16.224-4.261-17.811-12.157-22.824 -5.231-3.321-12.489-8.335-9.698-14.003 0.318-0.656 0.705-1.059 1.186-1.361 -0.138-1.296-0.22-2.048-0.326-3.251 -12.216 2.312-4.037 11.604-17.651 19.873 -2.06 1.247-4.075 2.097-6.543 3.416 4.879 4.251 16.31 18.506 18.561 27.717 8.378-8.476 8.442-12.181 14.294-19.847 5.04-6.597 9.156-5.921 10.021 3.007 -0.476-2.682-1.603-6.787-4.045-6.787 -2.012 0-4.109 2.844-5.147 4.217 -5.809 7.667-6.742 13.154-15.352 20 -0.596-1.716-1.294-3.438-2.128-5.043 -3.412-6.604-13.291-19.595-14.342-20.887 -4.083 1.102-9.667 1.984-13.408 2.58 -24.442 3.897-33.916 8.81-37.519 44.213 89.639-0.87 126.166-0.49 192.932-0.49C195.594 218.524 193.953 206.642 190.188 199.647z",
    fill: "#09aac5",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2992",
    d: "M95.717 224.342c-3.653 0-6.286-0.061-7.83-0.178 0.466-2.48 1.856-7.125 2.656-9.437 -2.555-3.227-3.274-6.568-3.908-9.518 -0.377-1.754-0.705-3.274-1.361-4.468 0.136-0.077 0.49-0.274 0.49-0.274l-0.063-0.091c-1.685-2.413-3.682-5.039-5.754-6.277l0.34-0.566c1.692-2.82 4.515-7.526 6.942-9.985 4.186 3.168 8.991 9.141 10.865 12.259l0.035 0.057 0.066-0.01c1.296-0.193 2.722-0.309 3.815-0.309 2.926-4.474 7.014-9.048 10.768-12 1.966 1.719 5.101 6.956 6.614 9.487 0.293 0.488 0.517 0.863 0.65 1.074 -2.356 1.583-4.58 4.592-5.434 5.822l-0.054 0.077 0.074 0.059c0.338 0.263 0.988 0.809 1.331 1.15 -0.691 5.103-2.874 10.362-5.725 13.645 0.685 2.18 0.951 4.674 1.32 8.126l0.123 1.141c-0.251 0.003-0.797 0.014-1.564 0.029C107.169 224.216 101.044 224.342 95.717 224.342 95.718 224.342 95.718 224.342 95.717 224.342z",
    fill: "#141111",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2993",
    d: "M113.911 202.273c-0.201 4.322-1.702 7.874-4.265 12.068 2.646-3.301 5.655-8.274 6.313-13.127 -2.801-2.801-12.774-7.511-23.341-3.521C101.263 195.991 111.48 197.412 113.911 202.273z",
    fill: "#2c2526",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2994",
    d: "M143.952 181.126c-2.462 2.676-4.609 5.634-7.094 9.113 -3.192 4.465-5.719 8.218-7.293 12.92 1.813-9.701 7.918-18.479 15.435-25.159 -7.906-1.438-11.68-8.559-13.549-15.792 1.174 3.502 2.683 7.736 9.173 11.943 2.153 1.379 4.54 2.37 6.801 3.596C147.273 177.877 143.952 181.126 143.952 181.126zM186 198c5.681 7.102 8.332 16.221 10.11 25.565 -0.919-7.689-2.586-17.72-5.923-23.918 -9.662-17.92-26.803-14.749-44.614-19.556 -0.158 0.191-0.471 0.584-0.897 1.131C159.32 183.163 176.369 185.48 186 198zM52.575 177.747c2.261-1.226 4.647-2.217 6.801-3.596 6.49-4.207 7.999-8.441 9.173-11.943C66.68 169.441 62.906 176.563 55 178c7.517 6.681 13.621 15.458 15.435 25.159 -1.574-4.702-4.101-8.455-7.293-12.92 -2.484-3.479-4.632-6.438-7.094-9.113C56.048 181.126 52.727 177.877 52.575 177.747zM55.324 181.223c-0.427-0.547-0.739-0.939-0.897-1.131 -17.812 4.807-34.952 1.636-44.614 19.556 -3.337 6.198-5.004 16.229-5.923 23.918C5.668 214.221 8.319 205.102 14 198 23.631 185.48 40.68 183.163 55.324 181.223z",
    fill: "#545b8e",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2995",
    d: "M143.952 181.126c-2.462 2.676-4.609 5.634-7.094 9.113 -3.192 4.465-5.719 8.218-7.293 12.92 1.813-9.701 7.918-18.479 15.435-25.159 -7.906-1.438-11.68-8.559-13.549-15.792 1.174 3.502 2.683 7.736 9.173 11.943 2.153 1.379 4.54 2.37 6.801 3.596C147.273 177.877 143.952 181.126 143.952 181.126zM186 198c5.681 7.102 8.332 16.221 10.11 25.565 -0.919-7.689-2.586-17.72-5.923-23.918 -9.662-17.92-26.803-14.749-44.614-19.556 -0.158 0.191-0.471 0.584-0.897 1.131C159.32 183.163 176.369 185.48 186 198zM52.575 177.747c2.261-1.226 4.647-2.217 6.801-3.596 6.49-4.207 7.999-8.441 9.173-11.943C66.68 169.441 62.906 176.563 55 178c7.517 6.681 13.621 15.458 15.435 25.159 -1.574-4.702-4.101-8.455-7.293-12.92 -2.484-3.479-4.632-6.438-7.094-9.113C56.048 181.126 52.727 177.877 52.575 177.747zM55.324 181.223c-0.427-0.547-0.739-0.939-0.897-1.131 -17.812 4.807-34.952 1.636-44.614 19.556 -3.337 6.198-5.004 16.229-5.923 23.918C5.668 214.221 8.319 205.102 14 198 23.631 185.48 40.68 183.163 55.324 181.223z",
    fill: "#1fbad4",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2996",
    d: "M118.303 173c-4.485 2.492-8.283 4.938-10.802 8.379 0.979 0.283 3.556 0.964 4.767 2.375 -4.003 3.142-6.432 6.012-9.915 11.611 0.397-3.133 0.558-5.563 1.203-7.858 0.188-0.914 0.39-1.785 0.604-2.553l0.006 0.001c2.686-10.352 11.142-10.687 17.552-17.429 4.033-3.682 3.524-8.712 0.905-10.002 0.101-0.892 0.222-2.079 0.317-3.137 0.672 0.116 1.271 0.257 1.828 0.413C133.028 161.766 123.939 170.584 118.303 173zM80.601 173c4.485 2.492 9.97 5.445 12.482 8.587 -0.979 0.283-4.14 0.756-5.351 2.167 4.551 4.245 7.303 7.188 10.266 11.982 -0.397-3.133-0.908-5.935-1.554-8.229 -0.188-0.914-0.39-1.785-0.604-2.553l-0.006 0.001c-2.686-10.352-11.142-10.687-17.552-17.429 -4.033-3.682-3.524-8.712-0.905-10.002 -0.101-0.892-0.222-2.079-0.317-3.137 -0.672 0.116-1.271 0.257-1.828 0.413C68.311 162.904 75.536 170.056 80.601 173z",
    fill: "#009cb6",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2997",
    d: "M123.859 159.785c0.569 2.32-0.34 4.21-1.75 5.82 0.01-1.72 0.16-3.45 0.319-5.15 0.08-0.84 0.171-1.689 0.25-2.529C123.219 158.295 123.639 158.896 123.859 159.785zM77.309 160.815c0.11 1.47 0.24 2.939 0.27 4.41 -1.22-1.53-1.95-3.271-1.44-5.42 0.17-0.74 0.48-1.271 0.89-1.65C77.129 159.045 77.219 159.926 77.309 160.815z",
    fill: "#008ea6",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2998",
    d: "M192.56 200.686c-8.84-20.244-29.707-17.8-46.46-21.05 0.696-0.843 1.549-1.73 1.739-1.9 -2.635-1.86-11.126-5.595-14.239-12.38 -2.229-4.835-1.683-10.37-10.851-11.26 -0.503 2.816-1.225 9.009-1.09 12 -9.604 9.907-19.063 5.479-20.226 29.359l0.779-0.018c0 0 0.221-0.146 0.229-0.215 2.844-23.354 10.041-17.837 19.347-27.627 4.168-3.829 3.449-8.9 0.94-10.13 0.109-0.99 0.21-1.971 0.3-2.961 7.887 1.39 7.203 5.838 9.67 11.271 3.279 7.224 11.345 10.264 14.55 11.99 -4.338 3.729-7.473 8.221-10.939 13.069 -5.453 7.563-6.714 11.421-7.471 14.41 -8.276-8.33-8.281-11.981-14.2-19.74 -6.311-8.277-10.367-3.908-10.289 5.37 0.18-2.319 1.569-10.83 5.51-8.6 4.556 2.544 9.029 13.352 14.35 19.34 1.42 1.611 3.248 3.229 4.93 4.58 2.071-6.931 9.616-16.647 14.271-23.13 0.71-0.98 1.44-1.94 2.2-2.86 6.49 1.69 13.26 2.46 19.83 3.66 23.784 4.36 28.162 17.492 30.88 42.44 -37.937 0.194-79.138-0.603-192.71 0.489 1.646-16.292 4.431-29.61 14.5-36.81 4.32-3.1 9.33-4.72 14.49-5.75 7.19-1.43 14.66-2.17 21.79-4.02 0.83 1.01 1.62 2.05 2.39 3.13 8.804 12.243 11.1 14.931 14.07 22.85 10.018-7.514 14.024-21.616 19.54-24.05 3.84-1.69 5.08 6.42 5.26 8.729 0.075-9.841-4.519-15.681-13.81-0.22 -4.578 7.621-5.792 9.687-10.66 14.59 -1.955-7.948-12.36-22.256-18.44-27.5 3.772-2.028 10.592-4.438 14.24-11.3 2.409-4.707 1.339-10.294 9.69-11.89 0.09 1.029 0.2 2.05 0.31 3.08 -2.287 1.441-2.683 6.284 0.97 9.67 3.29 3.609 7.75 5.67 11.67 8.55 4.621 3.419 6.449 6.918 7.92 19.15 0.032 0.267 0.375 0.777 0.375 0.777l0.643-0.083c-0.379-8.482-1.601-15.681-6.567-19.825 -4.29-3.668-10.305-6.005-13.94-10.1 0.11-3.072-0.706-9.294-1.1-11.64 -8.308 0.811-8.378 5.859-10.14 10.279 -2.667 6.687-9.6 10.256-14.65 13.311 0.335 0.333 1.129 1.187 1.74 1.91 -6.99 1.369-14.23 1.76-21.24 2.989 -10.46 1.83-20.33 7.12-24.83 17.19 -3.418 7.642-4.409 18.603-4.66 26.99 -0.01 0.06-0.01 0.13-0.01 0.189 0.14 0.01 0.29 0.01 0.43 0.01 120.323 1.226 192.229-0.51 193.23-0.51C196.819 225.494 196.378 209.429 192.56 200.686zM122.109 165.605c0.015-2.591 0.373-5.593 0.569-7.68C124.151 158.933 125.021 162.281 122.109 165.605zM77.579 165.226c-2.446-3.068-1.66-6.042-0.55-7.07C77.261 160.228 77.537 163.13 77.579 165.226z",
    fill: "#008197",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-head"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2774",
    d: "M47.001 83.974c-1.376-2.313-5.638-7.997-9.98-6.603 -2.749 0.882-3.293 3.765-3.735 6.311 -0.588 3.386 0.471 10.083 1.389 12.503 0.881 2.325 3.533 6.816 5.264 8.527 2.13 2.1 4.775 8.793 5.194 9.487 0.66 1.097 1.536 2.745 4.122 2.538 2.853-0.229 4.584-1.742 5.856-1.999C58.253 114.109 50.582 89.995 47.001 83.974z",
    fill: "#f3d4cf",
    stroke: "#c5796d",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2775",
    d: "M44.197 97.997c-0.132-0.548 0.007-1.47 0.142-2.362 0.124-0.812 0.24-1.579 0.169-2.121 -0.267-2.032-1.773-5.893-2.757-7.985 -1.132-2.407-2.963-5.439-5.262-6.221 -0.95-0.324-1.575 0.063-1.938 0.456 -0.266 0.289-0.325 0.627-0.238 0.667 0.086 0.04 0.285-0.24 0.572-0.504 0.235-0.216 0.579-0.402 1.051-0.363 -0.19 1.011-1.167 6.49-0.744 10.225 0.333 2.938 1.593 5.131 1.79 5.46 0.029 0.346 0.077 0.685 0.148 1.014 0.929 4.287 4.971 9.163 6.378 10.758 0.259 0.295 0.531 0.47 0.598 0.398 0.066-0.072-0.094-0.364-0.353-0.66 -1.388-1.585-5.391-6.442-6.289-10.579 -0.952-4.389 2.318-10.896 3.048-12.272 0.371 0.646 0.687 1.267 0.93 1.785 0.19 0.406 0.402 0.881 0.619 1.395 -0.429 0.718-3.434 5.958-2.338 10.153 0.406 1.546 2.235 3.54 3.447 4.086 0.667 0.301 0.919 0.75 1.209 1.271 0.336 0.604 0.718 1.288 1.828 1.784 0.225 0.102 0.429 0.142 0.61 0.142 0.313 0 0.551-0.126 0.725-0.276 0.018 0.266 0.017 0.604 0.009 0.917 -0.012 0.404 0.042 0.737 0.137 0.745 0.094 0.008 0.196-0.313 0.207-0.717 0.016-0.496 0.013-1.11-0.072-1.403 -0.248-0.865-1.008-1.841-1.813-2.875C45.221 99.896 44.403 98.844 44.197 97.997zM36.95 94.196c-2.177-6.731 0.656-12.54 1.144-13.464 0.85 0.775 1.6 1.811 2.21 2.824C39.86 84.365 37.041 89.669 36.95 94.196zM46.341 104.042c-1.004-0.447-1.339-1.051-1.666-1.633 -0.293-0.527-0.598-1.072-1.369-1.42 -0.168-0.075-0.352-0.191-0.542-0.323 -2.486-5.906 0.272-8.488 0.963-9.017 0.211 0.722 0.369 1.384 0.439 1.915 0.063 0.488-0.052 1.263-0.167 2.012 -0.142 0.929-0.286 1.89-0.137 2.512 0.226 0.926 1.069 2.009 1.884 3.057 0.723 0.929 1.466 1.888 1.721 2.67C47.359 103.972 47.017 104.345 46.341 104.042z",
    fill: "#c5796d",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2776",
    d: "M152.736 83.974c1.377-2.313 5.639-7.997 9.98-6.603 2.75 0.882 3.293 3.765 3.736 6.311 0.588 3.386-0.471 10.083-1.389 12.503 -0.881 2.325-3.533 6.816-5.266 8.527 -2.129 2.1-4.775 8.793-5.193 9.487 -0.658 1.097-1.535 2.745-4.121 2.538 -2.854-0.229-4.584-1.742-5.857-1.999C141.484 114.109 149.156 89.995 152.736 83.974z",
    fill: "#f3d4cf",
    stroke: "#c5796d",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2777",
    d: "M153.727 100.913c-0.805 1.033-1.564 2.009-1.813 2.875 -0.086 0.293-0.088 0.907-0.072 1.403 0.012 0.404 0.113 0.725 0.207 0.717s0.148-0.341 0.137-0.745c-0.008-0.313-0.008-0.651 0.01-0.917 0.174 0.15 0.412 0.276 0.725 0.276 0.182 0 0.385-0.04 0.609-0.142 1.109-0.496 1.492-1.18 1.828-1.784 0.289-0.52 0.543-0.969 1.209-1.271 1.213-0.546 3.041-2.54 3.447-4.086 1.096-4.194-1.908-9.435-2.338-10.153 0.217-0.513 0.43-0.988 0.619-1.395 0.244-0.518 0.559-1.139 0.93-1.785 0.73 1.377 4 7.883 3.049 12.272 -0.896 4.137-4.9 8.994-6.289 10.579 -0.258 0.296-0.418 0.588-0.352 0.66 0.066 0.071 0.338-0.104 0.598-0.398 1.406-1.596 5.449-6.471 6.379-10.758 0.07-0.329 0.117-0.668 0.146-1.014 0.197-0.329 1.459-2.523 1.791-5.46 0.422-3.735-0.555-9.214-0.744-10.225 0.473-0.039 0.814 0.146 1.051 0.363 0.287 0.264 0.486 0.544 0.572 0.504s0.027-0.378-0.238-0.667c-0.363-0.393-0.988-0.779-1.938-0.456 -2.299 0.782-4.131 3.814-5.262 6.221 -0.984 2.093-2.49 5.953-2.758 7.985 -0.072 0.542 0.045 1.309 0.17 2.121 0.135 0.892 0.273 1.814 0.141 2.362C155.336 98.844 154.518 99.896 153.727 100.913zM159.434 83.555c0.611-1.013 1.361-2.049 2.211-2.824 0.488 0.925 3.32 6.733 1.145 13.464C162.697 89.669 159.879 84.365 159.434 83.555zM152.27 103.816c0.254-0.782 0.998-1.741 1.721-2.67 0.816-1.048 1.658-2.131 1.885-3.057 0.148-0.622 0.004-1.583-0.137-2.512 -0.115-0.749-0.23-1.524-0.166-2.012 0.068-0.531 0.227-1.193 0.438-1.915 0.691 0.529 3.449 3.111 0.965 9.017 -0.191 0.132-0.375 0.248-0.543 0.323 -0.771 0.348-1.074 0.893-1.369 1.42 -0.326 0.582-0.662 1.186-1.666 1.633C152.721 104.345 152.379 103.972 152.27 103.816z",
    fill: "#c5796d",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-wrap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4015",
    d: "M144.736 125.052c-4.549 9.721-18.57 27.825-28.601 32.018 -7.442 3.112-24.824 3.112-32.267 0 -10.029-4.192-24.05-22.297-28.601-32.018 -5.29-11.297-14.118-47.803-14.13-47.856 -1.3-4.912-1.996-10.066-2.004-15.382C39.082 28.339 66.289 1.168 99.907 1.116c33.621-0.052 60.913 27.032 60.963 60.506 0.009 5.316-0.669 10.473-1.952 15.389C158.901 77.063 150.045 113.711 144.736 125.052z",
    fill: "#f3d4cf",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4016",
    d: "M110.152 1.969c26.994 6.24 47.097 30.337 47.052 59.111 -0.009 5.315-0.704 10.471-2.004 15.382 -0.012 0.053-8.158 36.591-13.396 47.856 -4.417 9.497-18.244 26.812-27.867 31.286 -3.169 1.473-10.439 1.823-13.935 1.823 -3.494 0-10.765-0.351-13.933-1.823 -9.623-4.474-23.451-21.789-27.867-31.286 -5.239-11.266-13.385-47.803-13.396-47.856 -1.3-4.911-1.996-10.066-2.004-15.382C42.756 32.307 62.857 8.209 89.853 1.969 61.03 6.788 39.087 31.751 39.134 61.813c0.008 5.315 0.704 10.47 2.004 15.382 0.012 0.053 8.781 36.586 14.13 47.856 4.602 9.696 18.738 27.446 28.601 32.018 3.671 1.703 12.088 2.334 16.134 2.334 4.043 0 12.464-0.632 16.133-2.334 9.862-4.571 24-22.321 28.601-32.018 5.35-11.271 14.119-47.803 14.13-47.856 1.3-4.912 1.996-10.066 2.004-15.382C160.918 31.751 138.975 6.788 110.152 1.969z",
    fill: "#ebc3bd",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4017",
    d: "M144.736 125.052c-4.549 9.721-18.57 27.825-28.601 32.018 -7.442 3.112-24.824 3.112-32.267 0 -10.029-4.192-24.05-22.297-28.601-32.018 -5.29-11.297-14.118-47.803-14.13-47.856 -1.3-4.912-1.996-10.066-2.004-15.382C39.082 28.339 66.289 1.168 99.907 1.116c33.621-0.052 60.913 27.032 60.963 60.506 0.009 5.316-0.669 10.473-1.952 15.389C158.901 77.063 150.045 113.711 144.736 125.052z",
    fill: "none",
    stroke: "#c5796d",
    strokeWidth: 1.5,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4080",
    d: "M100.091 139.322c-4.952 0-6.142-3.033-6.142-3.033 6.246 2.316 11.836-0.124 11.836-0.124S104.446 139.322 100.091 139.322z",
    fill: "url(#SvgjsLinearGradient4081)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4084",
    d: "M85.595 129.671c2.677-0.132 7.545-1.077 10.096-0.988 1.319 0.046 2.63 0.953 4.007 1.242 0.958 0.202 3.935-1.1 4.915-1.162 2.572-0.162 7.409 0.744 9.771 0.92 0.13 0.011 0 0 0 0s-5.776 7.727-14.463 7.725C90.09 137.406 85.595 129.671 85.595 129.671S85.463 129.678 85.595 129.671z",
    fill: "#f771a9",
    stroke: "#e85391",
    strokeWidth: 0.75,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4085",
    d: "M114.739 129.405c-0.045-0.131-0.461-0.189-0.624-0.139 -0.3 0.094-0.663 0.521-1.313 0.686 -0.748 0.191-5.021 1.431-6.193 1.49 -2.365 0.118-4.438 0.943-6.76 0.938 -2.323-0.005-4.34-0.929-6.716-1.058 -1.18-0.065-5.194-1.216-5.947-1.4 -0.65-0.16-0.89-0.574-1.162-0.686 -0.189-0.077-0.652-0.02-0.743 0.105 -0.079 0.107 0.088 0.609 0.2 0.75 0.271 0.336 1.103 0.506 1.667 0.647 0.779 0.199 4.759 1.366 5.949 1.433 2.305 0.13 4.308 1.125 6.612 1.127 2.306 0.003 4.405-0.904 6.729-1.022 1.195-0.062 5.53-1.313 6.332-1.513 0.58-0.146 1.388-0.399 1.672-0.68C114.58 129.95 114.785 129.538 114.739 129.405z",
    fill: "#c92066",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4086",
    d: "M99.799 136.138c-3.914 0-7.707-1.246-10.289-3.693 1.36 0.19 2.83 0.207 4.269 0.403 1.773 0.242 3.429 0.921 5.248 1.034 1.968 0.125 3.916-0.495 5.886-0.841 1.644-0.289 4.21-1.067 5.742-1.302C107.729 133.982 103.577 136.138 99.799 136.138zM105.256 131.043c1.49-0.149 3.855-0.879 5.226-1.04 -1.406-0.413-3.829-0.279-5.576-0.441 -1.506-0.139-3.244 0.861-4.817 1.016 -1.774 0.175-2.94-1.233-4.607-1.369 -1.809-0.147-3.787 0.559-5.336 0.915 1.387 0.188 2.877 0.239 4.309 0.517 1.753 0.341 3.405 0.992 5.223 1.054C101.537 131.757 103.419 131.226 105.256 131.043z",
    fill: "#ff8ebd",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4087",
    d: "M105.695 133.406c-0.308 0.01-0.625 0.025-0.93 0.051 -0.351 0.028-0.668 0.069-0.961 0.123 -0.538 0.099-1.074 0.233-1.638 0.369 -0.888 0.216-1.726 0.392-2.662 0.391 -0.15 0-0.301-0.007-0.452-0.017 -0.764-0.055-1.521-0.217-2.191-0.412 -0.693-0.204-1.353-0.401-2.019-0.492 -0.128-0.017-0.259-0.029-0.387-0.042 -0.409-0.036-0.836-0.052-1.255-0.063 1.734 1.396 4.128 2.038 6.468 2.041C102.079 135.356 103.946 134.512 105.695 133.406z",
    fill: "#ffa8cc",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3947",
    d: "M60.632 83.957c1.226-1.179 9.091-2.674 13.631-2.075 7.183 0.947 13 7.285 13 7.285s-4.836 3.083-13.61 3.56C67.873 93.042 62.061 89.309 60.632 83.957z",
    fill: "url(#SvgjsRadialGradient3948)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-left",
    transform: "translate(-1 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4005",
    d: "M83.199 89.25c-1.231 4.522-5.896 7.187-10.429 5.944 -4.528-1.241-7.203-5.918-5.97-10.442 1.23-4.526 5.905-7.19 10.434-5.947C81.761 80.045 84.433 84.723 83.199 89.25z",
    fill: "#4e60a3",
    stroke: "#152975",
    strokeWidth: 0.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4006",
    d: "M81.878 89.354c-1.202 3.473-4.827 5.499-8.357 4.531 -3.258-0.894-5.315-4.02-5.048-7.325 1.209-0.096 2.532-0.124 3.904-0.056 -0.014 0.047-0.039 0.087-0.051 0.136 -0.434 1.594 0.576 3.265 2.256 3.726 1.685 0.461 3.401-0.462 3.835-2.056 0.055-0.208 0.085-0.417 0.093-0.623C79.66 88.108 80.792 88.651 81.878 89.354z",
    fill: "#6777b2",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4007",
    d: "M76.151 84.464c-1.703-0.487-3.44 0.485-3.88 2.181 -0.44 1.687 0.584 3.454 2.286 3.942 1.705 0.489 3.443-0.484 3.884-2.173C78.884 86.719 77.855 84.953 76.151 84.464zM76.523 90.46c-0.708 0.22-1.441-0.072-1.636-0.655 -0.188-0.582 0.231-1.228 0.945-1.443 0.712-0.22 1.442 0.073 1.639 0.651C77.665 89.593 77.241 90.24 76.523 90.46z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4008",
    d: "M70.482 91.476c-0.523 0.314-1.307 0.034-1.754-0.633 -0.448-0.66-0.381-1.451 0.145-1.767 0.521-0.311 1.311-0.03 1.755 0.632C71.07 90.37 71.006 91.162 70.482 91.476z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4009",
    d: "M81.673 86.632c-1.198 0.718-2.999 0.072-4.02-1.445 -1.02-1.518-0.867-3.331 0.332-4.047 1.196-0.721 3-0.074 4.015 1.444C83.019 84.101 82.871 85.913 81.673 86.632z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.9
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3972",
    d: "M55.332 88c0 13.808 8.06 24.999 18 24.999s18-11.191 18-24.999c0-13.809-8.06-25.001-18-25.001S55.332 74.191 55.332 88zM60.632 83.957c1.226-1.179 9.091-2.674 13.631-2.075 7.183 0.947 13 7.285 13 7.285s-4.836 3.083-13.61 3.56C67.873 93.042 62.061 89.309 60.632 83.957z",
    fill: "#f3d4cf",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3973",
    d: "M74.182 96.592c9.412 2.223 18.451-1.61 20.194-8.565 1.738-6.956-4.478-14.395-13.892-16.622 -9.414-2.224-18.453 1.609-20.195 8.565C58.55 86.927 64.765 94.365 74.182 96.592zM60.632 83.957c1.226-1.179 9.091-2.674 13.631-2.075 7.183 0.947 13 7.285 13 7.285s-4.836 3.083-13.61 3.56C67.873 93.042 62.061 89.309 60.632 83.957z",
    fill: "url(#SvgjsRadialGradient3974)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3978",
    d: "M60.632 83.957c1.226-1.179 9.091-2.674 13.631-2.075 7.183 0.947 13 7.285 13 7.285s-4.836 3.083-13.61 3.56C67.873 93.042 62.061 89.309 60.632 83.957z",
    fill: "url(#SvgjsRadialGradient3979)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3982",
    d: "M87.433 83.657c-6.502-4.251-4.054-3.09-16.23-6.703 3.344 0.5 9.572 2.066 11.707 3.32C84.073 80.928 86.433 82.783 87.433 83.657z",
    fill: "#c5796d",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3983",
    d: "M55.34 82.979c0 0 2.084 1.306 3.713 1.307 0.129 0.766 2.241 4.259 5.873 6.344 5.49 3.154 11.897 2.18 18.014 0.643 2.995-0.746 2.81-1.52 7.773-2.07 -3.897-1.57-3.485-2.497-8.891-5.423 2.468 0.471 5.783 2.315 5.783 2.315 -1.237-1.452-9.917-6.796-23.826-7.508 0 0 4.649 1.088 6.399 1.769 -8.05 1.097-10.242-0.113-10.669-0.435 0.357 0.302 1.188 1.24 3.004 1.852 -1.878 0.143-5.312-0.867-5.312-0.867s0.867 0.826 2.628 1.965C58.323 83.595 55.34 82.979 55.34 82.979zM60.632 84.074c1.226-1.137 9.091-2.58 13.631-2.001 7.183 0.913 13 7.026 13 7.026s-4.836 2.974-13.61 3.434C67.873 92.836 62.061 89.236 60.632 84.074z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3955",
    d: "M139.368 83.957c-1.226-1.179-9.091-2.674-13.631-2.075 -7.183 0.947-13 7.285-13 7.285s4.836 3.083 13.61 3.56C132.127 93.042 137.939 89.309 139.368 83.957z",
    fill: "url(#SvgjsRadialGradient3956)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-right",
    transform: "translate(1 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4010",
    d: "M133.199 89.25c-1.231 4.522-5.896 7.187-10.429 5.944 -4.528-1.241-7.203-5.918-5.97-10.442 1.23-4.526 5.905-7.19 10.434-5.947C131.761 80.045 134.433 84.723 133.199 89.25z",
    fill: "#4e60a3",
    stroke: "#152975",
    strokeWidth: 0.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4011",
    d: "M131.878 89.354c-1.202 3.473-4.827 5.499-8.357 4.531 -3.258-0.894-5.315-4.02-5.048-7.325 1.209-0.096 2.532-0.124 3.904-0.056 -0.014 0.047-0.039 0.087-0.051 0.136 -0.434 1.594 0.576 3.265 2.256 3.726 1.685 0.461 3.401-0.462 3.835-2.056 0.055-0.208 0.085-0.417 0.093-0.623C129.66 88.108 130.792 88.651 131.878 89.354z",
    fill: "#6777b2",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4012",
    d: "M126.151 84.464c-1.703-0.487-3.44 0.485-3.88 2.181 -0.44 1.687 0.584 3.454 2.286 3.942 1.705 0.489 3.443-0.484 3.884-2.173C128.884 86.719 127.855 84.953 126.151 84.464zM126.523 90.46c-0.708 0.22-1.441-0.072-1.636-0.655 -0.188-0.582 0.231-1.228 0.945-1.443 0.712-0.22 1.442 0.073 1.639 0.651C127.665 89.593 127.241 90.24 126.523 90.46z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4013",
    d: "M120.482 91.476c-0.523 0.314-1.307 0.034-1.754-0.633 -0.448-0.66-0.381-1.451 0.145-1.767 0.521-0.311 1.311-0.03 1.755 0.632C121.07 90.37 121.006 91.162 120.482 91.476z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4014",
    d: "M131.673 86.632c-1.198 0.718-2.999 0.072-4.02-1.445 -1.02-1.518-0.867-3.331 0.332-4.047 1.196-0.721 3-0.074 4.015 1.444C133.019 84.101 132.871 85.913 131.673 86.632z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.9
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3993",
    d: "M126.668 62.999c-9.94 0-18 11.193-18 25.001 0 13.808 8.06 24.999 18 24.999s18-11.191 18-24.999C144.668 74.191 136.608 62.999 126.668 62.999zM126.348 92.727c-8.774-0.476-13.61-3.56-13.61-3.56s5.817-6.338 13-7.285c4.54-0.6 12.405 0.896 13.631 2.075C137.939 89.309 132.127 93.042 126.348 92.727z",
    fill: "#f3d4cf",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3994",
    d: "M139.711 79.971c-1.742-6.956-10.781-10.79-20.195-8.565 -9.414 2.227-15.63 9.666-13.892 16.622 1.743 6.955 10.782 10.788 20.194 8.565C135.235 94.365 141.45 86.927 139.711 79.971zM126.348 92.727c-8.774-0.476-13.61-3.56-13.61-3.56s5.817-6.338 13-7.285c4.54-0.6 12.405 0.896 13.631 2.075C137.939 89.309 132.127 93.042 126.348 92.727z",
    fill: "url(#SvgjsRadialGradient3995)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3999",
    d: "M139.368 83.957c-1.226-1.179-9.091-2.674-13.631-2.075 -7.183 0.947-13 7.285-13 7.285s4.836 3.083 13.61 3.56C132.127 93.042 137.939 89.309 139.368 83.957z",
    fill: "url(#SvgjsRadialGradient4000)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4003",
    d: "M112.567 83.657c6.502-4.251 4.054-3.09 16.23-6.703 -3.344 0.5-9.572 2.066-11.707 3.32C115.927 80.928 113.567 82.783 112.567 83.657z",
    fill: "#c5796d",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4004",
    d: "M140.17 82.871c1.761-1.139 2.628-1.965 2.628-1.965s-3.434 1.009-5.312 0.867c1.815-0.612 2.646-1.55 3.004-1.852 -0.427 0.321-2.619 1.531-10.669 0.435 1.75-0.681 6.399-1.769 6.399-1.769 -13.909 0.712-22.589 6.056-23.826 7.508 0 0 3.315-1.844 5.783-2.315 -5.405 2.926-4.993 3.854-8.891 5.423 4.964 0.551 4.778 1.325 7.773 2.07 6.116 1.537 12.523 2.511 18.014-0.643 3.632-2.085 5.744-5.579 5.873-6.344 1.629-0.001 3.713-1.307 3.713-1.307S141.677 83.595 140.17 82.871zM126.348 92.533c-8.774-0.459-13.61-3.434-13.61-3.434s5.817-6.113 13-7.026c4.54-0.579 12.405 0.864 13.631 2.001C137.939 89.236 132.127 92.836 126.348 92.533z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-facehighlight-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2753",
    d: "M140.204 113.007c0.035 22.275-17.995 40.365-40.273 40.396 -22.274 0.036-40.361-17.993-40.396-40.272C59.501 90.857 77.53 72.77 99.808 72.735 122.083 72.701 140.171 90.73 140.204 113.007z",
    fill: "url(#SvgjsRadialGradient2754)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2757",
    d: "M135,55.999c0,19.329-15.671,35-35,35c-19.329,0-35-15.671-35-35s15.671-35,35-35C119.329,20.999,135,36.67,135,55.999z",
    fill: "url(#SvgjsRadialGradient2758)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3141",
    d: "M74.799 69.068c-4.425-0.475-21.252 3.714-21.252 3.714s16.789-6.74 23.757-5.667c5.188 0.798 14.397 5.077 12.706 7.339C88.649 76.275 84.408 70.1 74.799 69.068z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3142",
    d: "M109.731 74.187c-1.713-2.292 7.592-6.31 13.546-6.804 7.117-0.59 22.914 4.085 22.914 4.085s-15.9-2.628-20.377-2.106C115.998 70.506 111.11 76.031 109.731 74.187z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2890",
    d: "M92.281 116.235c-0.745 2.063 5.028 4.289 7.218 4.426 2.374 0.147 9.024-2.899 7.896-4.991 -1.185-2.197-5.63-0.286-7.547-0.286C97.94 115.384 93.276 113.479 92.281 116.235z",
    fill: "#e4b3ab",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2891",
    d: "M102.207 117.221c-0.243-0.522 1.194-1.333 1.748-1.493 0.777-0.226 2.505 0.238 2.438 0.831 -0.06 0.521-1.603-0.169-2.105-0.022C103.767 116.687 102.435 117.712 102.207 117.221zM95.214 116.742c0.706 0 1.753 0.457 1.945 0.057 0.229-0.479-1.56-1.065-2.086-1 -0.434 0.052-1.991 0.958-1.777 1.338C93.496 117.49 94.284 116.742 95.214 116.742z",
    fill: "#c5796d",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2892",
    d: "M99.857 113.479c0.669 0 1.807-0.637 1.978-1.9 0.754-5.575-0.521-20.246-1.978-20.246 -1.365 0-2.508 15.024-2.155 20.246C97.789 112.86 99.099 113.479 99.857 113.479",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.2,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-front"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2971",
    d: "M44.483 18.786v192.7h39.633c-0.985-7.894-2.345-15.114-3.827-18.896 -7.734-19.635-34.67-24.746-29.979-50.592l0.186-0.036c5.161 11.272 7.599 17.786 19.622 19.774 -16.696-13.644-13.473-26.335-11.147-42.457 1.357-9.407-1.612-16.768-3.584-24.324 2.337-6.986 3.574-13.578 4.833-21.104C71.469 6.622 121.799 9.658 136.22 52.964c9.121 27.391 1.487 36.087 12.741 53.306 0.534 12.012 3.037 24.947-11.378 41.925 -3.168 3.731-7.858 7.637-11.999 10.247 15.048-1.334 23.306-15.722 28.299-29.979l0.183 0.058c-6.601 55.459-31.788 30.36-34.347 82.965h41.151v-192.7H44.483z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2972",
    d: "M84.239 24.512c0 0 13.507 2.744 15.441 8.394 -9.837-0.448-14.145-3.676-28.021 1.726C74.877 29.073 84.239 24.512 84.239 24.512zM116.354 23.835c0 0-14.886-0.596-16.673 9.07 9.837-0.448 15.855-4.834 29.83 1.466C127.59 28.832 116.354 23.835 116.354 23.835z",
    fill: "#0c080c",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2973",
    d: "M171.325 103.155c12.474-84.818-28.429-117.88-66.57-108.483C62.686-15.575 30.577 5.914 25.649 64.39c-0.889 20.541 1.352 36.037 1.709 39.729 -2.823 5.811-4.602 12.117-5.334 18.632 -2.28 1.989-4.366 3.558-6.692 5.203 1.216-0.168 3.034-0.383 6.451-1.384 -0.802 22.784 10.506 26.852 9.795 45.72 -0.663 12.739-0.707 13.817 1.769 22.173 6.55 22.107-3.539 20.229-0.849 47.579 31.104-1.338 46.501 4.047 119.532-0.472 1.616-0.101 12.444-0.799 16.533-0.559 -16.247-55.787 11.274-50.916 2.58-79.354C163.35 136.169 184.674 127.674 171.325 103.155zM120.349 232.486c0.313 3.851 0.855 8.563 1.039 9.658 -14.026 0.059-13.942-0.431-36.432-0.219 0.397-13.065 1.519-40.587-1.77-48.975 -8.064-20.475-33.709-27.085-35.086-49.86l0.195-0.036c5.38 11.757 9.681 16.499 22.217 18.573 -17.408-14.226-13.83-25.25-13.383-42.226 0.265-9.903-1.679-17.482-3.736-25.362 2.437-7.282 3.738-14.154 5.041-22.003 5.299-31.981 23.306-56.507 41.03-39.238 0.001-0.001 0.225-0.316 0.225-0.316 0.096 0.134 0.084 0.114 0.202 0.302 15.169-16.919 29.792-2.734 37.781 17.474 11.073 27.991 1.55 37.627 13.281 55.582 0.56 12.526 1.191 25.365-13.838 43.069 -3.304 3.889-7.355 7.003-11.67 9.727 15.688-1.395 25.436-14.789 30.639-29.654l0.191 0.059C141.093 186.96 112.813 144.06 120.349 232.486z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2974",
    d: "M168.564 241.012c-4.089-0.24-14.917 0.458-16.533 0.559 -7.593 0.47-14.551 0.831-20.979 1.104 0.627-18.603-6.242-38.093 2.549-55.675 4.409-9.624 18.398-19 21.398-31 0.559-2.235 1.938-7.965 2.429-12.944 3.441 21.68-17.092 41.785-12.299 63.68 4.266-14.529 12.416-38.893 17.552-49.096 -0.563 16.096-1.812 20.566-1.289 30.668 4.13-9.095 7.526-16.68 5.584-38.498 0 0 2.598 6.715 4.168 11.848C179.839 190.096 152.317 185.225 168.564 241.012zM161.744 152.235c14.178-34.092-4.985-37.232-10.55-59.281C145.21 69.242 145.199 27.485 124 23c-10.773-2.279-19.332 1.04-24.926 9.434 0.13 0.122 0.26 0.239 0.39 0.366 0.001-0.001 0.225-0.316 0.225-0.316 0.096 0.134 0.084 0.114 0.202 0.302 15.169-16.919 29.792-2.734 37.781 17.474 11.073 27.991 1.55 37.627 13.281 55.582 2.666 23.645-7.074 41.159-25.508 52.796 15.263-7.068 28.199-18.51 30.174-46.749l0.398 0.199C161.471 119.218 164.952 140.731 161.744 152.235zM154.398 45c1.833 21.549 4.026 42.923 16.985 58.268 -0.021-0.038-0.038-0.074-0.059-0.112 0.178-1.207 0.604-4.451 0.76-5.638C166.309 90.678 160.708 78.757 159 66c-2.141-15.982 0.07-34.47-15.9-46C150.849 26.708 154.398 36 154.398 45zM69 18C44 33 50.146 61.473 44.146 84c-3.188 11.97-11.551 22.788-20.646 30.744 -0.609 2.384-1.069 4.813-1.377 7.277C60.299 97.473 45.24 48.478 61.199 30.666c11.568-12.911 25.383-17.769 38.489 1.817C96.415 16.706 79 13 69 18zM82.258 25.4c-7.133 1.456-14.761 9.231-18.923 16.342 -6.467 11.048-7.485 28.27-12.653 46.717 -4.4 15.707-13.998 30.571-33.68 39.249 26.759-5.687 35.423-30.752 36.391-33.667 2.437-7.282 3.738-14.154 5.041-22.003 5.26-31.746 23.042-56.139 40.64-39.604C93.415 26.512 90.127 23.793 82.258 25.4zM68.733 161.296c0.579 0.115 1.161 0.229 1.779 0.332 -17.408-14.226-14.13-25.25-13.683-42.226 0.255-9.563-1.65-17.359-3.626-24.951 -0.523 1.394-1.105 2.744-1.716 4.073C60.569 121.579 41.722 142.818 68.733 161.296zM146.702 161.628c9.171-9.346 13.167-29.969 11.369-43.484 -0.817 4.008-1.474 8.073-2.426 12.056 0.149-0.404 0.296-0.81 0.438-1.217l0.191 0.059c-15.183 57.919-43.463 15.019-35.927 103.445 0.313 3.851 0.855 8.563 1.039 9.658 -14.026 0.059-13.942-0.431-36.432-0.219 0.397-13.065 1.519-40.587-1.77-48.975 -7.75-19.678-44.052-31.323-33.378-62.632 -9.689 13.094-4.59 24.13 1.678 31.309 35.12 44.05 24.852 49.003 26.454 81.047 11.177 0.333 30.093 0.525 48.263-0.105C121.536 179.735 127.328 181.371 146.702 161.628zM39.184 142.011c-1.385-4.846 8.584-15.692 5.366-30.735C43.886 121.43 38.638 129.205 36 138c-3.999 33.884 27.286 39.376 14 74 0-13-2.667-19.437-7.667-31.437C42.333 196.563 49 207 41 223c0 0 2.761-11.765 0.26-17.418C32.879 180.272 39.439 170.276 33 154c-2.838-7.69-8.246-14.15-10.878-27.926 0.677 19.739 10.59 29.425 9.958 46.216 -0.663 12.739-1.207 13.817 1.268 22.173 6.55 22.107-3.539 20.229-0.849 47.579 12.221-0.525 22.025-0.014 33.847 0.527 2.261-24.406 5.03-40.444-7.662-60.172C51.814 171.72 37.453 160.703 39.184 142.011zM45 38c-4.149 20.744-5.556 42.857-18.478 58.357 0.366 3.807 0.713 6.488 0.837 7.762 -0.066 0.136-0.124 0.275-0.188 0.411C51.195 67.57 41.09 47.743 50 28c2-5 6.231-8.566 11-14C52.915 20.828 47 27 45 38zM166.623 102.836C155.162 84.076 155.692 61.634 148 38c-4.507-13.846-24.446-39.649-48.506-6.168 11.159-14.396 23.65-15.006 31.307-10.431 6.19 3.699 10.544 10.145 13.544 17.145 7.068 18.138 5.753 34.787 13.753 52.787 5 12 12.048 22.146 12.416 32.828 -0.332 4.575-3.198 15.689-4.698 19.253 0.479-1.376 6.27-12.165 6.27-18.4C172.085 118.144 170.466 109.127 166.623 102.836zM71.522 9.661c3.306-2.748 25.504-5.422 29.751 11.058C98.289 4.859 78.927 5.073 71.522 9.661zM135.429 8.581c3.49 2.642 2.081 1.447-0.513-0.514 -13.694-8.515-27.51-1.497-33.308 12.366C109.649 3.393 126.768 2.02 135.429 8.581zM147.768 15.763c-17.909-25.073-41.461-16.292-47.154-2.327C108.07-2.146 131.988-5.355 147.768 15.763zM47.118 21.915c-2.079 4.494 4.73-15.523 28.092-20.133 8.363-1.692 19.382-0.871 24.746 6.221C91.351-4.505 59.979-4.11 47.118 21.915zM134.716 12.859c1.24 0.864 2.13 1.626 2.078 1.583 -0.177-0.117-1.063-1.067-2.619-2.098 -11.543-7.674-29.75 1.124-33.899 15.082C105.102 13.747 123.645 5.512 134.716 12.859zM65.39 15.566c-3.443 2.883 4.383-2.277 6.732-2.839 8.25-2.126 24.014-0.522 28.82 11.981C96.429 10.93 77.129 7.13 65.39 15.566z",
    fill: "#1b141c",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2975",
    d: "M54.287 8.395c-6.063 5.795-8.245 8.121-12.733 15.896C29.969 42.645 29.465 95.483 30.12 75.647 31.003 46.753 33.226 26.926 54.287 8.395zM40.166 46.282c-1.19 10.81 2.133-9.666 3.979-14.112C51.075 15.805 71.717-1.981 91.025 6.798c3.802 1.736 6.471 3.731 7.692 4.555C71.922-9.195 43.586 15.053 40.166 46.282zM140.025 11.352c4.61 4.55 8.293 8.722 8.248 8.671 -3.867-3.539-21.245-34.352-47.079-3.221C113.365 3.41 126.815-1.016 140.025 11.352zM91.268 18.114c5.95 4.151 11.459 11.672 10.709 10.672 -0.251-0.291-1.608-2.192-3.735-4.794C75.559-3.612 50 28.843 47.748 53.002 51.44 28.64 73.278 5.713 91.268 18.114zM148.446 35.102c0.914 2.425 1.39 3.932 1.306 3.63 -0.112-0.292-0.599-2.129-1.518-4.706 -7.781-22.254-29.125-27.144-48.288-4.222C119.501 8.442 139.361 12.269 148.446 35.102zM170.729 89.177c-0.008-0.391 0.217-2.754 0.27-6.182 0.46-22.099-4.53-58.257-22.219-71.904C171.765 31.294 170.628 90.434 170.729 89.177zM160.594 109.636c1.141 1.432 1.838 2.295 1.702 2.122 -6.983-11.994-4.544 1.486-14.992-43.759C151.208 88.03 150.813 97.418 160.594 109.636zM40.224 110.197c-3.71 3.778-2.039 2.239 0.691-0.536C55.243 92.089 52.19 85.149 56.037 63.719 52.939 77.874 52.532 97.469 40.224 110.197zM80.217 24.943c1.441-0.43 2.318-0.692 2.144-0.644 -4.026 1.411-20.332 4.076-24.18 27.199C61.569 36.735 70.158 28.113 80.217 24.943zM143.451 47.042c2.782 8.476-1.829-8.357-4.675-13.598 -5.338-10.289-12.488-12.038-23.153-11.645C133.024 21.025 137.857 30.72 143.451 47.042zM34.274 152.301c2.071 11.298 11.409 25.639 15.081 38.07 1.789 5.938 1.875 6.194-0.112-1.306 -11.232-35.413-21.715-39.51-10.232-69.374C39.011 119.691 30.189 136.554 34.274 152.301zM148.784 189.284c-0.385 2.617-0.607 4.203-0.555 3.89 9.005-39.146 13.987-26.598 11.758-65.936C160.009 171.216 154.996 151.983 148.784 189.284zM46.041 133.496c-8.804 20.717 5.362 28.95 22.507 53.013 3.892 6.425 2.585 4.246 1.648 2.489 -11.499-21.461-31.094-34.2-23.91-53.677 2.383-6.427 3.979-9.329 3.182-22.331C49.611 121.966 49.23 125.986 46.041 133.496zM52.428 119.592c-0.092 12.744-6.549 21.745 6.856 35.309 4.074 3.177-2.931-3.353-4.056-5.359 -2.187-3.878-3.819-8.571-3.37-13.059 0.683-13.909 1.296-1.389 0.912-29.999C52.413 116.792 52.728 110.031 52.428 119.592zM142.67 147.298c-1.671 2.148-4.705 4.313-5.604 6.149 -0.214 0.387 0.542-0.853 1.744-1.979 17.557-16.844 13.72-27.795 16.996-34.761C152.473 123.786 154.94 131.114 142.67 147.298zM126.529 187.542c-2.762 11.25-1.063 15.187-1.063 15.187 -0.185-1-0.322-1.582-0.322-3.37 2.057-31.334 25.247-25.986 31.597-60.146C151.157 167.077 131.887 167.036 126.529 187.542z",
    fill: "#3a353a",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2976",
    d: "M171.429 103.136c12.069-85.836-28.95-117.955-66.649-108.561 -63.629-15.205-85.202 40.694-77.51 109.5 -2.854 5.875-4.629 12.232-5.31 18.601 -2.671 2.329-6.03 4.794-7.03 5.43 2.281-0.256 4.492-0.737 6.75-1.4 -0.454 12.987 3.396 20.927 6.94 29.32 6.294 14.887 0.154 21.277 3.39 34.07 1.24 4.85 3.11 9.63 3.55 14.64 0.946 10.766-5.545 16.426-3.15 37.41 0.08 0 0.15-0.01 0.23-0.01 24.692-0.967 13.033-0.165 29.72 0.439 62.103 2.413 88.897-1.46 106.34-1.46 -12.259-39.767-0.309-49.433 3.61-63.05 3.343-11.656-3.539-17.892-3.11-27.43C170.279 131.121 182.242 124.247 171.429 103.136zM69.579 161.266c-11.588-2.079-16.382-8.37-21.42-19.061 -0.284-5.823 1.921-12.104 2.96-17.87 1.044-5.75 0.401-10.896-0.69-22.729 1.12-2.35 2.09-4.77 2.94-7.24 1.57 6.54 3.01 13.15 3.04 19.83C56.463 128.817 50.079 147.932 69.579 161.266zM21.699 126.226c-1.71 0.529-3.46 0.96-5.23 1.27 41.837-27.209 31.729-67.088 39.07-85.77 7.243-18.434 27.63-33.995 44.1-9.15 -0.06 0.08-0.109 0.15-0.16 0.23 -17.355-18.325-36.108 8.93-40.729 31.36 -4.49 21.877-6.914 51.458-35.12 61.41C23.629 125.575 21.699 126.205 21.699 126.226zM32.619 241.855c-0.543-9.458-0.846-11.33 0.73-18.64 1.28-5.961 3.59-12.12 3.23-18.271 -0.39-6.41-3.11-12.39-3.89-18.74 -0.75-6.14 0.5-12.31 0.53-18.46 0.082-12.213-10.172-20.935-9.61-41.63 8.104-2.688 15.358-7.616 20.94-14.84 0.917 21.249-5.573 19.928-6.48 31.84 -1.511 20.052 22.174 35.669 27.74 56.09 1.939 7.062 2.03 35.213 1.99 42.561C42.492 241.322 58.322 240.284 32.619 241.855zM67.999 241.766c1.762-47.609-0.21-49.127-16.54-70.601 -22.601-29.594-7.548-34.703-6.54-50.26 0.21-3.27 0-6.56-0.21-9.84 2.15-2.82 3.97-5.86 5.51-9.05 0.795 13.27 0.928 13.425 0.83 15.92 -0.627 17.156-14.775 28.272 12.29 53.859 21.941 20.76 20.976 18.661 21.51 70.03C79.229 241.865 73.609 241.865 67.999 241.766zM85.059 241.825c0.35-11.354 1.576-40.352-1.78-48.91 -8.071-20.492-33.704-27.098-35.08-49.83 0.323 1 3.402 7.811 6.93 11.45 4.472 4.623 9.446 6.313 15.75 7.25 -17.932-13.084-14.028-28.113-13.65-42.38 0.263-9.843-1.635-17.335-3.74-25.39 4.287-12.413 4.894-24.4 7.4-33.84 5.711-21.558 22.336-43.879 38.589-27.22 0.006-0.017 0.2-0.286 0.21-0.3 0.008 0.011 0.188 0.291 0.19 0.3 13.404-16.837 29.143-4.305 37.7 17.34 11.029 27.882 1.583 37.684 13.29 55.6 0.491 11.79 1.402 25.005-13.83 42.95 -3.366 3.96-8.398 7.835-12 9.92 15.66-0.846 25.939-14.893 31.14-29.75 -15.514 57.917-43.439 15.318-35.93 103.479 0.343 4.205 0.894 8.792 1.021 9.55C109.791 242.117 111.782 241.719 85.059 241.825zM163.389 147.476c7.729-35.545-14.471-31.226-17.31-59.59 -0.996-10.411-0.63-29.001-12.86-48.65 -8.754-14.108-21.634-20.468-33.27-6.5 -0.04-0.08-0.09-0.16-0.141-0.24 15.769-21.402 42.415-19.527 49.341 26.27 4.381 29.034 5.438 27.162 15.17 47.38C168.679 115.133 174.634 126.9 163.389 147.476zM151.329 106.596c2.058 3.087 4.326 5.995 6.521 9.05 0 16.35-13.219 39.914-30.75 42.47 2.52-1.54 4.96-3.229 7.09-5.25C150.003 137.833 152.699 124.613 151.329 106.596zM167.939 156.695c1.3 5.5 3.699 10.57 3.729 16.32 -1.432 16.422-17.601 23.629-3.31 67.67 -9.831-0.523-19.654 0.533-37.141 1.149 -0.459-25.169-2.177-31.864-0.949-42.59 2.851-25.063 24.016-23.109 27.159-56.189 -4.017 34.862-28.503 30.377-29.029 61.109 -0.033 2.001 2.4 37.353 2.43 37.681 -2.771 0.093-6.599 0.199-9.37 0.199 -7.985-81.762 13.702-65.904 27.891-91.109 4.94-8.745 8.701-22.552 8.76-34.92 8.21 11.655 7.685 17.531 4.77 32.819 5.384-8.491 9.791-22.53 6.51-32.88 -1.094-4.394-4.797-11.869-6.25-14.88 -10.84-22.439-8.965-23.64-13-45.33 -7.404-40.292-33.264-47.161-50.39-23.33 -17.552-27.954-45.346-8.197-49.08 25.4 -1.354 12.346-0.255 38.468-26.65 63.02 1.906-14.99 8.729-22.372 13.75-34.22 12.649-29.735 1.814-50.492 18.65-67.33C38.122 37.494 51 59.408 34.099 91.476c-1.94 3.67-4.1 7.24-6 10.939 -5.854-64.179 16.384-121.011 75.59-107.03 40.783-10.329 64.18 25.442 67.6 67.79 1.471 18.212-0.248 34.59-0.54 38.77 -2.87-4.89-6.31-9.47-8.34-14.81 -11.876-31.337-1.556-52.06-19.32-67.28 18.119 16.345 6.485 41.9 19.79 71.61 2.613 4.897 5.803 9.391 8.16 14.36C180.63 126.046 163.44 137.618 167.939 156.695z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2880",
    d: "M100,18.13L100,18.13L100,18.13L100,18.13z",
    fill: "#26120b",
    strokeWidth: "none",
    opacity: 1
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "SvgjsRect1033",
    width: 200,
    height: 15,
    x: 0,
    y: 185,
    fill: "#ecf0f1",
    opacity: 0.5,
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "SvgjsText1034",
    fontFamily: "\"Roboto\", \"Helvetica Neue\", Helvetica, Arial, sans-serif",
    style: {
      fontSize: "0.84em",
      fontFamily: "&quot",
      textAnchor: "middle",
      fontWeight: 400,
      display: "none"
    },
    fontSize: "0.84em",
    textAnchor: "middle",
    fontWeight: 400,
    fill: "#000000",
    x: 100,
    y: 185
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "SvgjsTspan1035",
    dy: "1.2em",
    x: 100,
    style: {
      fontSize: "0.84em",
      fontFamily: "&quot",
      textAnchor: "middle",
      fontWeight: 400
    }
  }, "Created on AvatarMaker.com"))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1001"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2754",
    cx: 100,
    cy: 113,
    r: 40,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2755",
    stopOpacity: 0.5,
    stopColor: "#fff4f3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2756",
    stopOpacity: 0,
    stopColor: "#f3d4cf",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2758",
    cx: 100,
    cy: 57,
    r: 36,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2759",
    stopOpacity: 0.5,
    stopColor: "#fff4f3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2760",
    stopOpacity: 0,
    stopColor: "#f3d4cf",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3055",
    cx: -558.588,
    cy: -490.918,
    r: 84.646,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 140.5478 120.3577)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3056",
    stopOpacity: 0.8,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3057",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3059",
    cx: -565.337,
    cy: -492.691,
    r: 84.644,
    gradientTransform: "matrix(0.0991 8.856325e-004 -0.0011 0.0991 130.3774 136.3533)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3060",
    stopOpacity: 0.8,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3061",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3065",
    x1: 122.283,
    y1: 93.047,
    x2: 123.61,
    y2: 91.466,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3066",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3067",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3069",
    x1: 127,
    y1: 85,
    x2: 125,
    y2: 87,
    gradientTransform: "matrix(1 0 0 1 -50 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3070",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3071",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3073",
    x1: 130,
    y1: 81,
    x2: 126,
    y2: 85,
    gradientTransform: "matrix(1 0 0 1 -50 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3074",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3075",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3078",
    cx: -578.76,
    cy: -490.73,
    r: 84.646,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 192.4794 119.8404)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3079",
    stopOpacity: 0.8,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3080",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3082",
    cx: -584.778,
    cy: -487.329,
    r: 84.644,
    gradientTransform: "matrix(0.0991 8.856325e-004 -0.0011 0.0991 182.3104 135.839)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3083",
    stopOpacity: 0.8,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3084",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3088",
    x1: 120.284,
    y1: 93.047,
    x2: 121.611,
    y2: 91.467,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3089",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3090",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3092",
    x1: 127,
    y1: 85,
    x2: 125,
    y2: 87,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3093",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3094",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3096",
    x1: 130,
    y1: 81,
    x2: 126,
    y2: 85,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3097",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3098",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3948",
    cx: 126.403,
    cy: 87.57,
    r: 15.179,
    gradientTransform: "matrix(-0.9148 0.0479 0.0523 0.9986 184.4314 -6.6017)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3949",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3950",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3951",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3952",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3953",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3954",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3956",
    cx: 126.401,
    cy: 87.57,
    r: 15.179,
    gradientTransform: "matrix(0.9148 0.0479 -0.0523 0.9986 15.5691 -6.6017)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3957",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3958",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3959",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3960",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3961",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3962",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3964",
    cx: 126.403,
    cy: 87.57,
    r: 15.179,
    gradientTransform: "matrix(-0.9148 0.0479 0.0523 0.9986 184.4314 -6.6017)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3965",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3966",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3967",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3968",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3969",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3970",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3974",
    cx: 122.581,
    cy: 83.48,
    fx: 136.229,
    fy: 83.114,
    r: 16.914,
    gradientTransform: "matrix(0.99 0.1411 0.1085 -0.7608 -52.9892 129.6892)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3975",
    stopOpacity: 1,
    stopColor: "#e4b3ab",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3976",
    stopOpacity: 0.3,
    stopColor: "#e4b3ab",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3977",
    stopOpacity: 0,
    stopColor: "#f3d4cf",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3979",
    cx: 70.243,
    cy: 108.081,
    r: 29.51,
    gradientTransform: "matrix(1.0336 0 0 1.0336 -1.941 1.8777)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3980",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3981",
    stopOpacity: 0.3,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3985",
    cx: 126.401,
    cy: 87.57,
    r: 15.179,
    gradientTransform: "matrix(0.9148 0.0479 -0.0523 0.9986 15.5691 -6.6017)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3986",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3987",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3988",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3989",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3990",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3991",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3995",
    cx: 122.581,
    cy: 83.48,
    fx: 136.229,
    fy: 83.114,
    r: 16.914,
    gradientTransform: "matrix(-0.99 0.1411 -0.1085 -0.7608 252.9892 129.6892)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3996",
    stopOpacity: 1,
    stopColor: "#e4b3ab",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3997",
    stopOpacity: 0.3,
    stopColor: "#e4b3ab",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3998",
    stopOpacity: 0,
    stopColor: "#f3d4cf",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4000",
    cx: 70.243,
    cy: 108.081,
    r: 29.509,
    gradientTransform: "matrix(-1.0336 0 0 1.0336 201.941 1.8777)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4001",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4002",
    stopOpacity: 0.3,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4019",
    x1: 99.98,
    y1: 171.27,
    x2: 99.98,
    y2: 136.351,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-chinshadow-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4020",
    stopOpacity: 0.8,
    stopColor: "#e4b3ab",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4021",
    stopOpacity: 1,
    stopColor: "#c5796d",
    offset: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4081",
    x1: 100,
    y1: 141,
    x2: 100,
    y2: 138,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-mouth-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4082",
    stopOpacity: 1,
    stopColor: "#ebc3bd",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4083",
    stopOpacity: 1,
    stopColor: "#e4b3ab",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4096",
    cx: 100,
    cy: 225,
    r: 250,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-backs-gradient-single-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4097",
    stopOpacity: 0,
    stopColor: "#547980",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4098",
    stopOpacity: 1,
    stopColor: "#3f6971",
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmily);
export default __webpack_public_path__ + "static/media/emily.d34aecd9a11b82bb4fe3ee8536ee2b15.svg";
export { ForwardRef as ReactComponent };